import PurchaseOrderAttachment from '@/models/PurchaseOrder/PurchaseOrderAttachment';

export default class PurchaseOrderAttachmentFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.purchaseOrderId  = '';
		this.purchaseOrderPurchaseOrderNumber = '';
		this.poAttachmentId  = '';
		this.poAttachmentOriginalFilename = '';
		this.remarksMultiple = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			purchaseOrderId : '0',
			purchaseOrderPurchaseOrderNumber : '0',
			poAttachmentId : '0',
			poAttachmentOriginalFilename : '0',
			remarksMultiple : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}